import { LegacyEpisodePlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { getEpisodeOtt } from './get-episode-ott';
import { getEpisodeSkippableFragments } from './get-episode-skippable-fragments';
import { getMovieStartPosition } from './player';

export function getEpisodeStartPosition(episode: LegacyEpisodePlayerBaseInfoContent) {
    const skippableFragments = getEpisodeSkippableFragments(episode);
    const ott = getEpisodeOtt(episode);

    const currentTime = ott?.timing?.current || 0;
    const duration = ott?.duration || 1;

    return getMovieStartPosition({ currentTime, duration, skippableFragments });
}
